module.exports = __webpack_public_path__ + "media/images/kodiak-dd2dd139935209636d5bd29cde804a32.jpg";